import { graphql, useStaticQuery } from "gatsby"

export const useBlogPostsPreview = () => {
  const { blogPosts } = useStaticQuery(graphql`
    query BlogPosts {
      blogPosts: allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            frontmatter {
              date(formatString: "LL", locale: "pl-PL")
              title
              description
              author
              featuredimage {
                childImageSharp {
                  fluid(maxWidth: 1440) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  return { blogPosts }
}
